/*
 * Copyright (c) 2018 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import ServerError from '../ServerErrorView';
import NotFoundView from '../NotFoundView';

/**
 * Error view renders an appropriate error view based on the http status code returned by the server.
 *
 * @param props
 * @returns {*}
 * @private
 */
const _ErrorView = (props) => {
  // if props doesn't contain an error field, default to an empty object
  const {status} = (props.error || {});
  let statusSeries;

  if (status >= 500 && status < 600) {
    statusSeries = 500;
  } else if (status >= 400 && status < 500 && status !== 404) {
    statusSeries = 400;
  }

  switch (statusSeries) {
    case 500:
    case 400:
      return <ServerError {...props} />;

    default:
      return <NotFoundView {...props} />;
  }
};

/**
 * Define a errors shape that aligns with the fields returned by Spring Boot's BasicErrorController.  Spring is configured
 * to throw these into the initial state when exceptions are thrown by controllers.
 *
 * @type {{errors}}
 */
_ErrorView.propTypes = {
  error: PropTypes.shape({
    error: PropTypes.string,
    exception: PropTypes.string,
    message: PropTypes.string,
    path: PropTypes.string,
    timestamp: PropTypes.number,
    status: PropTypes.number
  })
};

/**
 * Map the application state to properties required by this component.
 * @param state
 * @returns {{errors: *|{status: number}|errors|{status}|{}|errorsReducer}}
 */
const mapStateToProps = (state) => {
  return { error: state.errors };
};

/* Inject errors state and dispatch() into props */
export const ErrorView = connect(
  mapStateToProps
)(_ErrorView);



// WEBPACK FOOTER //
// ./src/ErrorView/ErrorView.js